import { useGetCustomService } from 'hooks/rest/useGetCustomService';

type Option = { label: string[]; id: string };

const STALE_TIME = 5 * 60 * 1000;
const GC_TIME = 10 * 60 * 1000;

const adaptOptions = (obj: Array<{ id: string | number; name: string }> = []): Option[] => obj.map(({ id, name }) => ({ label: [name], id: String(id) }));

export const useOptionsDocLibrary = () => {
    const { data, isLoading } = useGetCustomService({
        service: 'documentService',
        api: 'getDocumentCategoriesList',
        enabled: true,
        staleTime: STALE_TIME,
        gcTime: GC_TIME,
    });

    const responseData = data as { data?: Array<{ id: string | number; name: string }> } | null;

    return {
        documentCategoriesList: adaptOptions(responseData?.data),
        isLoading,
    };
};
